import { LogoutIcon, Navbar as NavbarPrimitive } from '@medeloop/medeloop-components-library';

import { configuration, getLogoutUrl } from 'src/configuration';

import { ComponentProps, useMemo } from 'react';

import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { useLocalCookies } from 'src/hooks/use-local-cookies';
import { selectAccount } from 'src/store/selectors';
import { parseMainGroup } from 'src/utils/parse-main-group';

export const Navbar = () => {
  const account = useSelector(selectAccount);
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const { getSessionValues, removeAuthCookies } = useLocalCookies();

  const profile = useMemo(() => ({ ...account, role: parseMainGroup(account.groups) }), [account]);

  const handleLogout = () => {
    const { clientId } = getSessionValues();
    removeAuthCookies();
    window.location.replace(getLogoutUrl(clientId, location.pathname));
  };

  const items: ComponentProps<typeof NavbarPrimitive>['items'] = [
    {
      label: t('sign_out'),
      icon: LogoutIcon,
      onClick: handleLogout,
      shouldRender: true,
      className: '!text-red-600 hover:text-red-700',
    },
  ];

  return (
    <NavbarPrimitive
      title={t('account_header')}
      onBrandClick={() => navigate('/account/about')}
      navigation={[]}
      profile={profile}
      environment={configuration.medeloopEnvironment}
      items={items}
    />
  );
};
